import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {IDiagnosis} from '../_interface/diagnosis.model';
import {DiagnosisManageNewPosition} from '../_interface/diagnosis-manage-new-position.enum';
import {IDiagnosisIdNode} from '../_interface/diagnosisid-node.interface';
export const initDiagnosis = createAction(
	'[Diagnosis 📦] Init Diagnosis'
);

export const initDiagnosisError = createAction(
	'[Diagnosis 📦] Init Diagnosis error',
	props<{ err: any }>()
);

export const initDiagnosisFavouritesError = createAction(
	'[Diagnosis 📦] Init Diagnosis Favourites error',
	props<{ err: any }>()
);

export const loadDiagnosis = createAction(
	'[Diagnosis 📦] Load Diagnosis',
	props<{ diagnosis: IDiagnosis[] }>()
);

export const loadDiagnosisSuccess = createAction(
	'[Diagnosis] Loading Diagnoses Success',
	props<{
		diagnosis: IDiagnosis[];
		tree: IDiagnosisIdNode;
		flatTree: Record<string, string[]>;
	}>()
);

export const tryAddDiagnosis = createAction(
	'[Diagnosis 📦] Try add Diagnosis',
	props<{ diagnosis: IDiagnosis, position: DiagnosisManageNewPosition }>()
);

export const addDiagnosis = createAction(
	'[Diagnosis 📦] Add Diagnosis',
	props<{ diagnosis: IDiagnosis }>()
);

export const tryUpsertDiagnosis = createAction(
	'[Diagnosis 📦] Upsert Diagnosis',
	props<{ diagnosis: IDiagnosis }>()
);

export const addMultipleDiagnosis = createAction(
	'[Diagnosis 📦] Add Diagnosis',
	props<{ diagnosis: IDiagnosis[] }>()
);

export const upsertMultipleDiagnosis = createAction(
	'[Diagnosis 📦] Upsert Multiple Diagnosis',
	props<{ diagnosis: IDiagnosis[] }>()
);

export const upsertMultipleDiagnosisSuccess = createAction(
	'[Diagnosis] Upsert Multiple Diagnosis Success',
	props<{
		diagnosis: IDiagnosis[];
		tree: IDiagnosisIdNode;
		flatTree: Record<string, string[]>;
	}>()
);

export const tryUpdateDiagnosis = createAction(
	'[Diagnosis 📦] Try update Diagnosis',
	props<{ diagnosis: IDiagnosis }>()
);

export const updateDiagnosis = createAction(
	'[Diagnosis 📦] Update Diagnosis',
	props<{ diagnosis: IDiagnosis }>()
);

export const updateMultipleDiagnosis = createAction(
	'[Diagnosis 📦] Update multiple Diagnosis',
	props<{ diagnosis: Update<IDiagnosis>[] }>()
);

export const tryDeleteDiagnosis = createAction(
	'[Diagnosis 📦] Try delete Diagnosis',
	props<{ id: string }>()
);

export const deleteDiagnosisSuccess = createAction(
	'[Diagnosis 📦] Delete Diagnosis success',
	props<{ id: string }>()
);

export const deleteDiagnosisError = createAction(
	'[Diagnosis 📦] Delete Diagnosis error'
);

export const deleteMultipleDiagnosis = createAction(
	'[Diagnosis 📦] Delete Diagnosis',
	props<{ ids: string[] }>()
);

export const clearMultipleDiagnosis = createAction(
	'[Diagnosis 📦] Clear Diagnosis'
);

export const initEditDiagnosis = createAction('[Diagnosis 📦] Init edit diagnosis');
export const checkDiagnosisChildren = createAction('[Diagnosis 📦] Check diagnosis children', props<{forDiagnosisIds: string[]}>());
export const filterDisabledDiagnosis = createAction('[Diagnosis 📦] Filter disabled diagnosis', props<{filter: boolean}>());
export const getAllFavourites = createAction('[Diagnosis 📦] Get all diagnosis favourites');
export const loadFavouritesSuccess = createAction('[Diagnosis 📦] Load all diagnosis favourites success',
	props<{favourites: IDiagnosis[]}>());
export const addAsFavourite = createAction(
	'[Diagnosis 📦] Add diagnosis as favourite', props<{favouriteDiagnosisId: string}>());
export const removeAsFavourite = createAction(
	'[Diagnosis 📦] Remove diagnosis as favourite', props<{favouriteDiagnosisId: string}>());
export const toggleFavouriteSuccess = createAction('[Diagnosis 📦] Toggle diagnosis favourite success',
	props<{diagnosisId: string}>());

export const editFavouriteError = createAction('[Diagnosis 📦] Edit favourite error');
